import { render } from "./Profile.view.vue?vue&type=template&id=b4c82e0e"
import script from "./Profile.view.vue?vue&type=script&lang=js"
export * from "./Profile.view.vue?vue&type=script&lang=js"

import "./Profile.view.vue?vue&type=style&index=0&id=b4c82e0e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__